/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Email_Optional_For_InsInputs */

const en_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wise email (optional, for instant transfers)`)
};

const es_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico de Wise (opcional — para transferencias instantáneas)`)
};

const fr_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail Wise (facultatif — pour les virements instantanés)`)
};

const de_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wise-E-Mail (optional — für Sofortüberweisungen)`)
};

const ja_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiseメールアドレス (任意 — 即時送金用)`)
};

const zh_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wise 邮箱 (可选 — 用于即时转账)`)
};

const ar_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني في Wise (اختياري — للتحويلات الفورية)`)
};

const id_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Wise (opsional — untuk transfer instan)`)
};

const it_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail Wise (opzionale — per bonifici istantanei)`)
};

const ru_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email в Wise (необязательно — для мгновенных переводов)`)
};

const pt_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail do Wise (opcional — para transferências instantâneas)`)
};

const ko_wise_email_optional_for_ins = /** @type {(inputs: Wise_Email_Optional_For_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wise 이메일 (선택 사항 — 즉시 이체용)`)
};

/**
* | output |
* | --- |
* | "Wise email (optional, for instant transfers)" |
*
* @param {Wise_Email_Optional_For_InsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const wise_email_optional_for_ins = /** @type {((inputs?: Wise_Email_Optional_For_InsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Email_Optional_For_InsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_email_optional_for_ins(inputs)
	if (locale === "es") return es_wise_email_optional_for_ins(inputs)
	if (locale === "fr") return fr_wise_email_optional_for_ins(inputs)
	if (locale === "de") return de_wise_email_optional_for_ins(inputs)
	if (locale === "ja") return ja_wise_email_optional_for_ins(inputs)
	if (locale === "zh") return zh_wise_email_optional_for_ins(inputs)
	if (locale === "ar") return ar_wise_email_optional_for_ins(inputs)
	if (locale === "id") return id_wise_email_optional_for_ins(inputs)
	if (locale === "it") return it_wise_email_optional_for_ins(inputs)
	if (locale === "ru") return ru_wise_email_optional_for_ins(inputs)
	if (locale === "pt") return pt_wise_email_optional_for_ins(inputs)
	return ko_wise_email_optional_for_ins(inputs)
});